export const roleOptions = [
  { value: 'MANAGER', label: 'role.manager' },
  { value: 'STANDARD', label: 'role.standard' },
];
